import React, { useState, useRef, useEffect } from 'react';
import { IonContent, IonPage, IonCard, IonCardHeader, IonCardTitle, IonCardContent } from '@ionic/react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import NavBar from './NavBar';

import olha from "../assets/Teacher11.png";
import anton from "../assets/Teacher1.png";

const TeacherSelection: React.FC = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const [currentSlide, setCurrentSlide] = useState(1);
  const [isDarkMode, setIsDarkMode] = useState(window.matchMedia('(prefers-color-scheme: dark)').matches);
  const antonRef = useRef<HTMLDivElement>(null);
  const olhaRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    const handleChange = (e: MediaQueryListEvent) => setIsDarkMode(e.matches);
    
    mediaQuery.addEventListener('change', handleChange);
    return () => mediaQuery.removeEventListener('change', handleChange);
  }, []);

  const selectTeacher = (teacherId: string) => {
    history.push(`/tutor/${teacherId}`);
  };

  const handleScroll = () => {
    if (!antonRef.current || !olhaRef.current) return;

    const antonRect = antonRef.current.getBoundingClientRect();
    const olhaRect = olhaRef.current.getBoundingClientRect();
    const windowCenter = window.innerHeight / 2;

    const antonDistance = Math.abs(antonRect.top + antonRect.height / 2 - windowCenter);
    const olhaDistance = Math.abs(olhaRect.top + olhaRect.height / 2 - windowCenter);

    if (antonDistance < olhaDistance) {
      setCurrentSlide(1);
    } else {
      setCurrentSlide(2);
    }
  };

  const scrollToSlide = (slideNumber: number) => {
    if (slideNumber === 1 && antonRef.current) {
      antonRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
      setCurrentSlide(1);
    } else if (slideNumber === 2 && olhaRef.current) {
      olhaRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
      setCurrentSlide(2);
    }
  };

  return (
    <IonPage className="pb-16">
      <IonContent className="ion-padding" scrollEvents={true} onIonScroll={handleScroll}>
        <h1 className={`text-3xl font-bold text-center mb-8 ${isDarkMode ? 'text-white' : 'text-black'}`}>
          {t('teacherSelection.title')}
        </h1>

        <div className="max-w-md mx-auto space-y-6">
          <div ref={antonRef}>
            <IonCard className="overflow-hidden rounded-xl transform transition-all duration-300 hover:shadow-xl">
              <img 
                src={anton} 
                alt="Anton" 
                className="w-full h-64 object-cover"
              />
              <IonCardHeader>
                <IonCardTitle className="text-2xl font-bold mb-2">Anton</IonCardTitle>
              </IonCardHeader>
              <IonCardContent>
                <p className="text-gray-600 text-lg mb-4">{t('teacherSelection.antonDescription')}</p>
                <button
                  onClick={() => selectTeacher('anton')}
                  className="w-full bg-primary py-3 rounded-lg font-medium transition-colors duration-300 hover:bg-primary-dark"
                >
                  {t('teacherSelection.select')}
                </button>
              </IonCardContent>
            </IonCard>
          </div>

          <div ref={olhaRef}>
            <IonCard className="overflow-hidden rounded-xl transform transition-all duration-300 hover:shadow-xl">
              <img 
                src={olha} 
                alt="Olha" 
                className="w-full h-64 object-cover"
              />
              <IonCardHeader>
                <IonCardTitle className="text-2xl font-bold mb-2">Olha</IonCardTitle>
              </IonCardHeader>
              <IonCardContent>
                <p className="text-gray-600 text-lg mb-4">{t('teacherSelection.olhaDescription')}</p>
                <button
                  onClick={() => selectTeacher('olha')}
                  className="w-full bg-primary py-3 rounded-lg font-medium transition-colors duration-300 hover:bg-primary-dark"
                >
                  {t('teacherSelection.select')}
                </button>
              </IonCardContent>
            </IonCard>
          </div>
        </div>

        <div className="fixed right-6 top-1/2 transform -translate-y-1/2 flex flex-col gap-3 z-50">
          {[1, 2].map((num) => (
            <div 
              key={num}
              onClick={() => scrollToSlide(num)}
              className={`w-3 h-3 rounded-full transition-all duration-300 cursor-pointer hover:scale-110
                ${currentSlide === num ? 'bg-primary scale-125' : 'bg-gray-300'}
              `}
            />
          ))}
        </div>
      </IonContent>
      <NavBar />
    </IonPage>
  );
};

export default TeacherSelection;
